import { Box, Grid, Image, ResponsiveContext, Stack, Text, Tip } from "grommet";
import * as React from "react";
import Avatar from "react-avatar";
import { usePalette } from "react-palette";
import { Link } from "react-router-dom";
import { AliasBadgeViewModel, BadgeViewModel } from "../badges/BadgeStore";
import { useDarkMode } from "../components/DarkModeSwitch";

interface UserAliasCardProps {
    id: string;
    name: string;
    email: string;
    photoUri: string;
    splashUri: string;
    rating: number;
    discordID?: string;
    children?: React.ReactNode;
    badges: AliasBadgeViewModel[];
}

const UserAliasCard = ({ id, name, email, photoUri, splashUri, rating, children, discordID, badges }: UserAliasCardProps) => {
    const [isDarkMode] = useDarkMode();
    const [color, selectColor] = React.useState("#000000");

    const { data, loading, error } = usePalette(splashUri);

    React.useEffect(() => {
        if (color == "#000000") {
            // selectColor(data?.vibrant || "#000000");
        }
    }, [data]);

    const badgeOne = badges[0];
    const badgeTwo = badges[1];

    const size = React.useContext(ResponsiveContext);
    const isSmall = size === "small";

    return (
        <Box 
            align="center" 
            pad="small" 
            width={isSmall ? "100%" : { max: "50%", min: "large" }} 
            style={{ position: "relative" }} 
            gap="small"
        >
            <Link to={`/aliases/${id}`} style={{ width: "100%" }}>
                <Stack fill anchor="center">
                    <Box fill background={{ image: `url(${splashUri})` }} style={{ overflow: "hidden", filter: "drop-shadow(2px 4px 6px black)" }} round="5px">
                        <Stack fill anchor="bottom-right">
                            <Box align="center" pad={isSmall ? "small" : "medium"}>
                                <Avatar 
                                    email={!photoUri ? email : ""} 
                                    name={name} 
                                    round={"18px"} 
                                    size={isSmall ? "120" : "180"} 
                                    src={photoUri} 
                                    style={{ filter: `drop-shadow(2px 4px 10px ${color})` }}
                                ></Avatar>
                            </Box>
                        </Stack>
                    </Box>
                    <Box direction="row" fill justify="center" gap={isSmall ? "xsmall" : "xlarge"}>
                        <Box>
                            {badgeTwo && (
                                <Tip content={badgeTwo.badge.name}>
                                    <Image 
                                        src={badgeTwo.badge.logoURI} 
                                        width={isSmall ? "80px" : "140px"} 
                                        style={{ filter: `drop-shadow(2px 4px 10px ${color})` }}
                                    ></Image>
                                </Tip>
                            )}
                        </Box>
                        <Box width={isSmall ? "80px" : "150px"}>&nbsp;</Box>
                        <Box>
                            {badgeOne && (
                                <Tip content={badgeOne.badge.name}>
                                    <Image 
                                        src={badgeOne.badge.logoURI} 
                                        width={isSmall ? "80px" : "140px"} 
                                        style={{ filter: `drop-shadow(2px 4px 10px ${color})` }}
                                    ></Image>
                                </Tip>
                            )}
                        </Box>
                    </Box>
                </Stack>
            </Link>
            <Box>
                <Text size={isSmall ? "large" : "xlarge"}>{name}</Text>
            </Box>
            {children}
        </Box>
    );
};

export default UserAliasCard;
